
const ArtistCard = ({ artist }) => {
    console.log(artist)
      const baseUrl = process.env.REACT_APP_API_URL ;
      const imageUrl = artist.Picture?.formats?.small?.url
    ? `${baseUrl}${artist.Picture.formats.small.url}` 
    : "/path/to/default-image.jpg"; // Fallback image URL
  return (
    <div className="artist-card">
    <div className="artist-card__image-container">
      <img 
        className="artist-card__image"
        src={imageUrl} 
        alt={artist.Title}
      />
        <div className="artist-card__overlay-content">
            <h4 className="artist-card__instrument">{artist.Instruments}</h4>
            <h3 className="artist-card__title">{artist.Title}</h3>
        </div>
    </div>

      <div className="artist-card__content">
        <p className="artist-card__description">{artist.Description}</p>
      </div>
    </div>
  );
};

export default ArtistCard;